import React from 'react';
import { MdMenu } from 'react-icons/md';
import ipl from "../components/images/ipl-logo-new-old.png";
import { useStateContext } from "../contexts/ContextProvider";


const teamLogos = {
  "Mumbai Indians": "https://scores.iplt20.com/ipl/teamlogos/MI.png",
  "Royal Challengers Bengaluru": "https://scores.iplt20.com/ipl/teamlogos/aFPMviEPyJ1710927747rcb.png",
  "Chennai Super Kings": "https://scores.iplt20.com/ipl/teamlogos/CSK.png",
  "Rajasthan Royals": "https://scores.iplt20.com/ipl/teamlogos/RR.png",
  "Sunrisers Hyderabad": "https://scores.iplt20.com/ipl/teamlogos/SRH.png",
  "Kolkata Knight Riders": "https://scores.iplt20.com/ipl/teamlogos/KKR.png",
  "Lucknow Super Giants": "https://scores.iplt20.com/ipl/teamlogos/gPLvfvSC1X1711457972LSG.png",
  "Gujarat Titans": "https://scores.iplt20.com/ipl/teamlogos/GT.png",
  "Delhi Capitals": "https://scores.iplt20.com/ipl/teamlogos/DC.png",
  "Punjab Kings": "https://scores.iplt20.com/ipl/teamlogos/PBKS.png",
 
  // Add more team logos here as needed
};


const Navbar = () => {
  const { screenSize, setActiveMenu } = useStateContext();
  // Convert the teamLogos object to an array of [teamName, logoUrl] pairs
  const teamLogosArray = Object.entries(teamLogos);

  return (
    <div className="flex relative gap-4 justify-center items-center p-2 mb-4 bg-gradient-to-r from-blue-400 to-blue-900 md:gap-20">
      {screenSize <= 900 && (
        <button
          className="absolute left-4 top-1/2 p-2 text-white -translate-y-1/2"
          onClick={() => setActiveMenu(true)}
        >
          <MdMenu className="text-3xl" />
        </button>
      )}
     
      {/* Left side team logos - hide on mobile */}
      <div className="hidden gap-4 md:flex md:gap-16">
        {teamLogosArray.slice(0, 5).map(([teamName, logoUrl]) => (
          <a href="/" key={teamName} title={teamName}>
            <img src={logoUrl} alt={teamName} width={40} height={40} />
          </a>
        ))}
      </div>

      <a href="/" title='IPL'>
        <img src={ipl} alt="IPL Logo" width={80} />
      </a>


      {/* Right side team logos - hide on mobile */}
      <div className="hidden gap-4 md:flex md:gap-16">
        {teamLogosArray.slice(5, 11).map(([teamName, logoUrl]) => (
          <a href="/" key={teamName} title={teamName}>
            <img src={logoUrl} alt={teamName} width={40} height={40} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Navbar;